export default function(data) {
  var self = this;
  self.campaigns = ko.observableArray();
  self.paginator = ko.observable();
  self.searchQuery = ko.observable();
  self.$el = $('#admin_coupon_campaigns_listing');


  self.sendOnClick = function() {
    $('#campaignsSearch').on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $('#campaignsSearch').blur();
        self.filterChanged();
      }
    });
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.campaignsListing);

  };


  self.campaignsListing = function (url, params) {
    Kadenze.UIUtil.showLoadingIndicator(self.$el);

    //load the entries info from the server
    var url = url ? url : Kadenze.Routes.admin_coupon_campaigns_path();

    $.ajax({
      type: 'GET',
      url: url,
      data: params,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).success(function (data) {
      self.bindData(data);
    }).error(function (data) {
      console.log(data);
    }).always(function (data) {
      Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      Kadenze.PaginationBinding.applyBindingsWithTextInput(self.campaignsListing);
    });
  };

  self.filterChanged = function () {
      var params = {
        q: self.searchQuery(),
      };

    self.campaignsListing(null, $.param(params));
  };

  self.bindData = function(data) {
    var mapped = ko.mapping.fromJS(data.campaigns);
    self.campaigns(mapped());
    self.paginator(data.paginator);
  };

  const __construct = function(that) {
    console.log('constructor called for AdminCouponCampaignsListing');
    that.bindData(data);
  }(this);
}

